import { CheckOutlined, CloseOutlined, FormOutlined } from '@ant-design/icons'
import React from 'react'

export default function IntakeFormSection() {
    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                <FormOutlined />
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Intake Forms
                </span>
                {/* <Tag color='orange' style={{ fontFamily: 'tradeGothic' }}>Will not be merged</Tag> */}
            </div>
            <div style={{ padding: 8 }}>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>History/Physical</div>
                    <CheckOutlined style={{ color: '#49aa19' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>Consent</div>
                    <CheckOutlined style={{ color: '#49aa19' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>Good Faith Exams</div>
                    <CloseOutlined style={{ color: '#ff0000' }} />
                </div> */}

                All intake forms from both profiles will be merged into the surviving profile. 
                The most recent form (Consent, History and Physical, and GoodFaith) among them will be set as the active one.
                

            </div>
        </div>
    )
}
